(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@wix/image-client-api"), require("react"), require("react-dom"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["imageClientSDK", "react", "reactDOM", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["ProfileEditorMode"] = factory(require("@wix/image-client-api"), require("react"), require("react-dom"), require("lodash"));
	else
		root["ProfileEditorMode"] = factory(root["imageClientSDK"], root["React"], root["ReactDOM"], root["_"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__97354__, __WEBPACK_EXTERNAL_MODULE__31195__, __WEBPACK_EXTERNAL_MODULE__43596__, __WEBPACK_EXTERNAL_MODULE__38092__) {
return 